// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./assets/css/base.css";
import Vue from 'vue'
//设置生产环境
Vue.config.silent = true;
Vue.config.devtools = false;
//设置当前服务访问域名
window.HTTP_SERVER = abp.http_server;
window.HTTPS = abp.https;
window.JAVA_SERVER = abp.java_server
//import fastclick from 'fastclick'
import router from './routers'
import $ from './assets/js/touch'

window.Zepto = window.$ = $
import base64 from 'assets/js/base64'
import Prius from 'assets/js/jsBridge'
import 'assets/js/site'
import 'assets/js/toast'
import store from 'assets/js/store'
//import Validator from 'assets/js/validator'
import vueResource from 'vue-resource'

require('vue-swipe/dist/vue-swipe.css')


Vue.use(vueResource)
Vue.http.options.emulateJSON = true
Vue.http.interceptors.push(function (request, next) {
    // ...
    // 请求发送前的处理逻辑
    request.body = Object.assign(request.body, {
        appVer: '1.9.0',
        channelId: 3000001,
        platType: 3,
        activitySource: sessionStorage.getItem('activitySource'),
        activeId: sessionStorage.getItem('activeId'),
    })
    // ...
    next(function (response) {
        // ...
        // 请求发送后的处理逻辑
        // ...
        // 根据请求的状态，response参数会返回给successCallback或errorCallback
        return response
    })
})
//Vue.use(Validator)
import FastClick from 'fastclick'

if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function () {
        FastClick.attach(document.body);
    }, false);
}
window.Prius = Prius
let vue = new Vue({
    router,
    store,
    template: '<router-view></router-view>'
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js